import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'

/**
 * My Messages — 고객 본인의 문의 대화(judahsWeb/INQUIRY_THREAD_PLAN.md §4.1).
 *
 * 토큰은 **고객 토큰을 명시해서** 싣는다. 기본 Authorization 은 스태프 토큰(localStorage)이 있으면
 * 그것을 먼저 쓰는데(api.ts getAccessToken), 같은 브라우저에서 백오피스에 로그인해 있으면
 * 이 경로가 스태프 토큰으로 가서 401 이 난다. 401 이어도 스태프 토큰 갱신을 시도하지 않는다(isRefresh false).
 */
const customerAuthHeader = (): { [key: string]: string } => {
	try {
		const token: string = sessionStorage.getItem('accessCustomerToken') || ''
		return token === '' ? {} : { Authorization: `Bearer ${token}` }
	} catch (error) {
		return {}
	}
}

const connect = async (
	method: 'get' | 'post',
	uri: string,
	{ body = {}, query = {} }: { body?: object; query?: { [key: string]: any } } = {},
): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: method,
			uri: uri,
			body: body,
			query: query,
			customHeaders: customerAuthHeader(),
			isRefresh: false,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 목록 한 페이지 — [{ items, hasMore }] */
export const getMyInquiries = (cursor = '') =>
	connect('get', '/customer-inquiry', { query: cursor === '' ? {} : { cursor: cursor } })

/** 대화 한 건 — 열면 서버가 「새 답변」 표시를 끈다 */
export const getMyInquiryThread = (inquiryId: string) =>
	connect('get', `/customer-inquiry/${encodeURIComponent(inquiryId)}`)

/** 댓글 — [{ item, status }] */
export const addMyInquiryComment = (inquiryId: string, body: string) =>
	connect('post', `/customer-inquiry/${encodeURIComponent(inquiryId)}/comment`, {
		body: { body: body },
	})

/** 답변 첨부 — [{ fileName, contentType, base64 }] */
export const getMyInquiryReplyFile = (inquiryId: string, fileId: string) =>
	connect(
		'get',
		`/customer-inquiry/${encodeURIComponent(inquiryId)}/file/${encodeURIComponent(
			fileId,
		)}`,
	)

const customerInquiryApi = {
	getMyInquiries,
	getMyInquiryThread,
	addMyInquiryComment,
	getMyInquiryReplyFile,
}

export default customerInquiryApi
